module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content document",
    class: [_vm.documentType, _vm.docOrientation]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRaw),
      expression: "showRaw"
    }],
    staticClass: "raw"
  }, [_vm._t("raw-header", function() {
    return [_c('header', {
      staticClass: "raw-header"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": _vm.logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "header"
    }, _vm._l((_vm.header), function(block, key) {
      return _c(block.type, {
        key: key,
        tag: "component",
        attrs: {
          "data": block
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "page-counter"
    })])]
  }), _vm._v(" "), _c('div', {
    staticClass: "raw-body"
  }, [_vm._t("raw-body", function() {
    return _vm._l((_vm.body), function(block, key) {
      return _c('div', {
        staticClass: "page-block"
      }, [_c(block.type, {
        key: 'block-' + key,
        tag: "component",
        attrs: {
          "data": block
        }
      })], 1)
    })
  })], 2), _vm._v(" "), _c('footer', {
    staticClass: "raw-footer"
  }, [_vm._t("raw-footer", function() {
    return _vm._l((_vm.footer), function(block, key) {
      return _c(block.type, {
        key: 'block-footer-' + key,
        tag: "component",
        attrs: {
          "data": block
        }
      })
    })
  })], 2)], 2), _vm._v(" "), _vm._l((_vm.document.pages), function(page, key) {
    return _c('document-page', {
      key: key,
      attrs: {
        "body": page.content,
        "footer": page.footer,
        "header": page.header
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c58c97a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document/DocumentContainer.vue
// module id = 679
// module chunks = 0